<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Add New Factory') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  id="factory-focus-me"
                  v-model="form.factory_name"
                  :label="`${$t('Factory Name')} *`"
                  name="factory_name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('factory_name')"
                  v-validate="'required'"
                />
              </v-flex>
              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="form.factory_description"
                  :label="$t('Description')"
                  name="factory_description"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('factory_description')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {},
      keepForm: false
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addFactory: 'factories/addFactory'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('factory-focus-me').focus()
      })
    },

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            this.addFactory(this.form)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
